import Vue from 'vue'
import { ToastPlugin, ModalPlugin, BootstrapVueIcons } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'
import VueConfirmCode from '@/libs/confirm-code'
import jwt from '@/auth/jwt/useJwt'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/sweet-alerts'
import '@/libs/toastification'
import '@core/scss/vue/libs/vue-select.scss'
import '@/libs/basicPrototype'

Vue.use(VueConfirmCode)
Vue.component('vue-confirm-code', VueConfirmCode.default)

Vue.use(BootstrapVueIcons)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

const mountApp = () => {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount('#app')
}

const token = jwt.getToken()

if (token) {
  store.dispatch('auth/fetchUser').finally(() => {
    mountApp()
  })
} else {
  mountApp()
}
